import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import { login, post } from './util'
import Button from './components/Button'
import logo from './logo.png'

const Login = () => {
  const history = useHistory()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)

  const handleSubmit = e => {
    e.preventDefault()
    setLoading(true)
    post('admin/login', { email, password })
      .then(ret => {
        setLoading(false)
        login(ret.token)
        history.push('/dashboard')
      })
      .catch(err => {
        setLoading(false)
        alert(err.message)
      })
  }

  return (
    <div className='min-h-screen bg-surface flex items-center justify-center px-4'>
      <div className='w-full max-w-md rounded-[32px] border border-slate-200 shadow-soft bg-white p-8 space-y-6'>
        <div className='flex items-center justify-between'>
          <div>
            <p className='text-2xl font-semibold text-ink'>Surge Enterprise</p>
            <p className='text-sm text-slate-500'>Sign in to manage your organization</p>
          </div>
          <img src={logo} alt='Logo' width='48' height='48' />
        </div>
        <form className='space-y-4' onSubmit={handleSubmit}>
          <div>
            <label className='text-sm font-medium text-slate-600'>Work Email</label>
            <input
              type='email'
              autoComplete='username'
              value={email}
              onChange={e => setEmail(e.target.value)}
              className='mt-1 w-full rounded-2xl border border-slate-200 px-4 py-2.5 focus:border-ink focus:ring-1 focus:ring-ink'
            />
          </div>
          <div>
            <label className='text-sm font-medium text-slate-600'>Password</label>
            <input
              type='password'
              autoComplete='current-password'
              value={password}
              onChange={e => setPassword(e.target.value)}
              className='mt-1 w-full rounded-2xl border border-slate-200 px-4 py-2.5 focus:border-ink focus:ring-1 focus:ring-ink'
            />
          </div>
          <Button type='submit' className='w-full justify-center' disabled={loading}>
            {loading ? 'Signing In…' : 'Sign In'}
          </Button>
          <button
            type='button'
            className='w-full text-center text-sm text-slate-500 hover:text-ink'
            onClick={() => history.push('/')}
          >
            Back to marketing site
          </button>
        </form>
      </div>
    </div>
  )
}

export default Login
